import * as React from "react";

import LabeledInput from "../../LabeledInput";
import Money from "../../Money";
import MoneyInput from "../../MoneyInput";

const humanize = require("underscore.string/humanize");

require("../../../assets/stylesheets/components/underwriter_dashboard/shared/editable_field.scss");

const FontAwesome = require("react-fontawesome");

interface EditableFieldProps {
  inputType: any;
  inputName: any;
  fieldName: any;
  originalValue: any;
  handleOnChange: any;
  handleOnBlur?: any;
  originalValueDisplay?: Function;
  changedValue?: any;
  options?: any;
  editing?: boolean;
  placeholder?: string;
  readOnly?: boolean;
}

class EditableField extends React.Component<EditableFieldProps, any> {
  constructor(props: EditableFieldProps) {
    super(props);
    this.state = {
      editing: props.editing || false,
    };
  }

  handleOnChange(fieldName, ev) {
    ev.stopPropagation();
    const field = {
      name: fieldName,
      value: ev.target.value,
    };
    this.props.handleOnChange(field);
  }

  handleSelectChange(fieldName, option) {
    const value = option && option.hasOwnProperty("value") ? option.value : null;

    const field = {
      value,
      name: fieldName,
    };
    this.props.handleOnChange(field);
  }

  handleOnKeyDown(ev) {
    if (ev.keyCode === 13) {
      this.handleSubmit(ev);
    }
  }

  handleSubmit(ev) {
    const { handleOnBlur } = this.props;
    ev.stopPropagation();
    this.setState({ editing: false });
    if (handleOnBlur) {
      handleOnBlur(ev);
    }
  }

  editValue(ev) {
    ev.stopPropagation();
    this.setState({ editing: true });
  }

  clearValue(fieldName, ev) {
    ev.stopPropagation();
    const field = {
      name: fieldName,
      value: null,
    };
    this.props.handleOnChange(field);
  }

  getLabelForValue(value) {
    for (let i = 0; i < this.props.options.length; i += 1) {
      if (this.props.options[i].value === value) {
        return this.props.options[i].label;
      }
    }
    return value;
  }

  render() {
    const valueChanged =
      this.props.changedValue !== undefined &&
      this.props.changedValue !== null &&
      this.props.changedValue !== this.props.originalValue;
    const className =
      valueChanged && !this.state.editing
        ? "editable_field__old_value--strikethrough"
        : "editable_field__old_value";

    switch (this.props.inputType) {
      case "money": {
        return (
          <span>
            <span className={className}>
              {this.props.originalValue !== null && <Money value={this.props.originalValue} />}
            </span>
            {this.state.editing ? (
              <span className="editable_field__input_box">
                <div className="editable_field__label--bold">{humanize(this.props.fieldName)}</div>
                <MoneyInput
                  name={this.props.inputName}
                  value={this.props.changedValue}
                  onChange={this.handleOnChange.bind(this, this.props.fieldName)}
                  onBlur={this.handleSubmit.bind(this)}
                  onKeyDown={this.handleOnKeyDown.bind(this)}
                />
              </span>
            ) : (
              <span className="editable_field__changed_value_container">
                {valueChanged && (
                  <span className="editable_field__changed_value">
                    <Money value={this.props.changedValue} />
                    <span className="editable_field__icon">
                      <FontAwesome
                        name="trash"
                        onClick={this.clearValue.bind(this, this.props.fieldName)}
                      />
                    </span>
                  </span>
                )}
                {!this.props.readOnly && (
                  <span className="editable_field__icon">
                    <FontAwesome name="pencil" onClick={this.editValue.bind(this)} />
                  </span>
                )}
              </span>
            )}
          </span>
        );
      }
      case "text": {
        return (
          <span>
            <span className={className}>{this.props.originalValue}</span>
            {this.state.editing ? (
              <span className="editable_field__input_box">
                <div className="editable_field__label--bold">{humanize(this.props.fieldName)}</div>
                <LabeledInput
                  inputType={this.props.inputType}
                  inputName={this.props.inputName}
                  inputValue={this.props.changedValue}
                  onChange={this.handleOnChange.bind(this, this.props.fieldName)}
                  onBlur={this.handleSubmit.bind(this)}
                  onKeyDown={this.handleOnKeyDown.bind(this)}
                />
              </span>
            ) : (
              <span className="editable_field__changed_value_container">
                {valueChanged && (
                  <span className="editable_field__changed_value">
                    {this.props.changedValue}
                    <span className="editable_field__icon">
                      <FontAwesome
                        name="trash"
                        onClick={this.clearValue.bind(this, this.props.fieldName)}
                      />
                    </span>
                  </span>
                )}
                {!this.props.readOnly && (
                  <span className="editable_field__icon">
                    <FontAwesome name="pencil" onClick={this.editValue.bind(this)} />
                  </span>
                )}
              </span>
            )}
          </span>
        );
      }
      case "select": {
        return (
          <span>
            <span className={className}>{this.getLabelForValue(this.props.originalValue)}</span>
            {this.state.editing ? (
              <span>
                <div className="editable_field__label--bold">{humanize(this.props.fieldName)}</div>
                <LabeledInput
                  inputType="select"
                  inputValue={this.props.changedValue}
                  inputName={this.props.inputName}
                  options={this.props.options}
                  onChange={this.handleSelectChange.bind(this, this.props.fieldName)}
                  onBlur={this.handleSubmit.bind(this)}
                  placeholder={this.props.placeholder}
                />
              </span>
            ) : (
              <span>
                {valueChanged && (
                  <span className="editable_field__changed_value">
                    {this.getLabelForValue(this.props.changedValue)}
                    <span className="editable_field__icon">
                      <FontAwesome
                        name="trash"
                        onClick={this.clearValue.bind(this, this.props.fieldName)}
                      />
                    </span>
                  </span>
                )}
                {!this.props.readOnly && (
                  <span className="editable_field__icon">
                    <FontAwesome name="pencil" onClick={this.editValue.bind(this)} />
                  </span>
                )}
              </span>
            )}
          </span>
        );
      }
      case "selectBool": {
        return (
          <span>
            <span className={className}>{this.getLabelForValue(this.props.originalValue)}</span>
            {this.state.editing ? (
              <span>
                <div className="editable_field__label--bold">{humanize(this.props.fieldName)}</div>
                <LabeledInput
                  inputType="select"
                  inputValue={this.props.changedValue}
                  inputName={this.props.inputName}
                  options={this.props.options}
                  onChange={this.handleSelectChange.bind(this, this.props.fieldName)}
                  onBlur={this.handleSubmit.bind(this)}
                  placeholder={this.props.placeholder}
                />
              </span>
            ) : (
              <span>
                {valueChanged && (
                  <span className="editable_field__changed_value">
                    {this.getLabelForValue(this.props.changedValue)}
                    <span className="editable_field__icon">
                      <FontAwesome
                        name="trash"
                        onClick={this.clearValue.bind(this, this.props.fieldName)}
                      />
                    </span>
                  </span>
                )}
                {!this.props.readOnly && (
                  <span className="editable_field__icon">
                    <FontAwesome name="pencil" onClick={this.editValue.bind(this)} />
                  </span>
                )}
              </span>
            )}
          </span>
        );
      }
      default: {
        return (
          <span>
            <span className={className}>
              {this.props.originalValueDisplay
                ? this.props.originalValueDisplay(this.props.originalValue)
                : this.props.originalValue}
            </span>
            {this.state.editing ? (
              <span className="editable_field__input_box">
                <div className="editable_field__label--bold">{humanize(this.props.fieldName)}</div>
                <LabeledInput
                  inputType={this.props.inputType}
                  inputName={this.props.inputName}
                  inputValue={this.props.changedValue}
                  onChange={this.handleOnChange.bind(this, this.props.fieldName)}
                  onBlur={this.handleSubmit.bind(this)}
                  onKeyDown={this.handleOnKeyDown.bind(this)}
                />
              </span>
            ) : (
              <span className="editable_field__changed_value_container">
                {valueChanged && (
                  <span className="editable_field__changed_value">
                    {this.props.changedValue}
                    <span className="editable_field__icon">
                      <FontAwesome
                        name="trash"
                        onClick={this.clearValue.bind(this, this.props.fieldName)}
                      />
                    </span>
                  </span>
                )}
                {!this.props.readOnly && (
                  <span className="editable_field__icon">
                    <FontAwesome name="pencil" onClick={this.editValue.bind(this)} />
                  </span>
                )}
              </span>
            )}
          </span>
        );
      }
    }
  }
}

export default EditableField;
